import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const getLegacyB2BMode = () => {
  try {
    return localStorage.getItem("b2b_mode") === "true";
  } catch {
    return false;
  }
};

export const useUiStore = create(
  devtools(
    persist(
      (set) => ({
        isB2BMode: getLegacyB2BMode(),
        setB2BMode: (enabled) =>
          set({ isB2BMode: Boolean(enabled) }, false, "ui/setB2BMode"),
        enableB2BMode: () =>
          set({ isB2BMode: true }, false, "ui/enableB2BMode"),
        disableB2BMode: () =>
          set({ isB2BMode: false }, false, "ui/disableB2BMode"),
      }),
      {
        name: "reops-ui-store",
        partialize: (state) => ({ isB2BMode: state.isB2BMode }),
        migrate: (persistedState) => {
          if (persistedState && typeof persistedState.isB2BMode === "boolean") {
            return persistedState;
          }
          return {
            isB2BMode: localStorage.getItem("b2b_mode") === "true",
          };
        },
      }
    ),
    { name: "ui-store" }
  )
);
